@if (item && loaded) {
  <app-content-block
    [blocks]="blocks"
    [environmentJSON]="{ viewportMode: false }"/>
}
